var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.94705,
    height: 22.3666,
    rx: 1.97352,
    transform: "matrix(0.5 0.866025 0.866025 -0.5 1.92505 11.7417)",
    fill: "#208C72"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.94705,
    height: 15.7882,
    rx: 1.97352,
    transform: "matrix(0.5 0.866025 0.866025 -0.5 4.22754 15.73)",
    fill: "#1E3966"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.94705,
    height: 10.5255,
    rx: 1.97352,
    transform: "matrix(0.5 0.866025 0.866025 -0.5 6.53003 19.7168)",
    fill: "#EA1763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.2516fbfa04e8265bf73943b72ebbed88.svg";
export { ForwardRef as ReactComponent };